import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import "src/css/login.css";
import LoginForm from "src/forms/LoginForm";
import { URL_MAP_VIEW } from "src/router/routes";

const Login = () => {
    const navigate = useNavigate();
    const { schema } = useParams<{ schema: string }>();

    return (
        <Box className="background-container">
            <Box className="content">
                <Box className="icon-container">
                    <FontAwesomeIcon
                        className="close-icon"
                        size="2xs"
                        icon={faTimes}
                        onClick={() => navigate(`/${schema}${URL_MAP_VIEW}`)}
                    />
                </Box>
                <Box
                    component="img"
                    src="/static/images/logo.svg"
                    className="img-container"
                />
                <LoginForm />
            </Box>
        </Box>
    );
};

export default Login;
